import ProjectCard from './ProjectCard';

function Projects() {
  const projects = [
    {
      name: "Decibel",
      description: "A mobile app that uses motion and volume sensors to detect activity in spaces around college campuses and provides real-time information to students so they can find the right space for their needs. I developed this prototype app with a team of 6 for the NJIT Verizon Smart Campus Challenge, and it was selected as one of 3 winners out of 30+ teams.",
      githubUrl: "https://github.com/srineshselvaraj/Decibel",
      projectUrl: "https://decibel-njit.vercel.app/",
      images: ["decibel2.png"],
      technologies: [
        { name: "React"},
        { name: "Tailwind CSS" },
        { name: "Expo" }
      ]
    },
    {
      name: "Dataset Dashboard",
      description: "An interactive dashboard that lets users upload any dataset, select any target variable, generate bar charts for categorical features and correlation, and train a regression model with any combination of features. I built this project with a group of 3 as part of a class project.",
      githubUrl: "https://github.com/parkab/NJIT-CS301-Milestone4-Group9",
      images: ["/dashboard1.png"],
      technologies: [
        { name: "Python" },
        { name: "Dash" },
        { name: "scikit-learn" },
        { name: "pandas" },
        {name: "HTML"},
        {name: "CSS"}
      ]
    },
    {
      name: "COGnition",
      description: "An LLM-powered learning tool that allows users to quickly generate summaries, questions, and flashcards based on any given text, with OCR capabilities and a login system. I built this project in 24 hours with a team of 3 for HackNJIT 2024.",
      githubUrl: "https://github.com/srineshselvaraj/hacknjit-2024",
      images: ["/cognition1.jpg", "/cognition2.jpg", "/cognition3.jpg", "/cognition4.jpg"],
      technologies: [
        { name: "React" },
        { name: "Bootstrap" },
        { name: "Flask" },
        { name: "PostgreSQL" }
      ]
    },
    {
      name: "Tech Accessories Store",
      description: "A website for a fictional tech accessories store with a login system and product catalog. Consumers can browse products, and admins can manage the catalog and generate shipping labels. I built this project as part of a class project.",
      githubUrl: "https://github.com/srineshselvaraj/tech-accessories-store",
      images: ["/tas1.png", "/tas2.png", "/tas3.png", "/tas4.png", "/tas5.png"],
      technologies: [
        { name: "HTML" },
        { name: "CSS" },
        { name: "JavaScript" },
        { name: "PHP" },
        { name: "MySQL" }
      ]
    },
    {
      name: "Maritime Mortality",
      description: "A data analysis tool that can visualize and predict shipwreck survival rates based on year, age, and gender. I built this project in 24 hours for HackNJIT 2023.",
      githubUrl: "https://github.com/srineshselvaraj/maritime-mortality",
      images: ["/mm1.png", "/mm2.png", "/mm3.png", "/mm4.png"],
      technologies: [
        { name: "Python" },
        { name: "NumPy" },
        { name: "Pandas" },
        { name: "Matplotlib" },
        { name: "Scikit-learn" },
        { name: "Streamlit" }
      ]
    }
  ];

  const [featuredProject, ...otherProjects] = projects;

  return (
    <section className="section-wrap fade-up">
      <div className="mb-10 text-center">
        <p className="section-kicker">Portfolio</p>
        <h2 className="section-title mt-2">Featured Projects</h2>
      </div>

      {featuredProject && (
        <div className="mx-auto mb-8 max-w-5xl">
          <ProjectCard
            name={featuredProject.name}
            description={featuredProject.description}
            githubUrl={featuredProject.githubUrl}
            projectUrl={featuredProject.projectUrl}
            images={featuredProject.images}
            technologies={featuredProject.technologies}
            featured
            collapsible={false}
            defaultExpanded
            centerContent
            imageFill
            imageFrameClass="h-72 sm:h-96 md:h-[28rem]"
            animationDelay={0}
          />
        </div>
      )}

      <div className="mx-auto grid max-w-5xl gap-5 sm:gap-6">
        {otherProjects.map((project, index) => (
          <ProjectCard
            key={index}
            name={project.name}
            description={project.description}
            githubUrl={project.githubUrl}
            projectUrl={project.projectUrl}
            images={project.images}
            technologies={project.technologies}
            animationDelay={(index + 1) * 70}
          />
        ))}
      </div>
    </section>
  );
}

export default Projects; 